<template>
<div class="foot-wrapper">
  <div class="manual">
    <div class="title">系统使用说明</div>
    <div class="content">1、本查询系统的信息仅供参考，具体数据请以学校官网或考试院公布为准。</div>
    <div class="content">2、如对本系统有任何疑问请联系我们，联系方式:陈老师 15967693204 </div>
  </div>
  <div class="right">
    <div class="qrcode-list">
      <QrcodePop class="qrcode-item" :codeImageUrl="wechatCodeSrc" :iconImageUrl="wechatIconSrc" title="扫一扫微信联系我" />
      <QrcodePop class="qrcode-item" :codeImageUrl="androidCodeSrc" :iconImageUrl="androidIconSrc" title="扫一扫下载 Android App" />
    </div>
    <div>扫描二维码，高校信息一秒掌握</div>
  </div>
</div>
</template>

<script>
import QrcodePop from './widget/Qrcode_pop'

export default {
components:{
  QrcodePop
},
data(){
  return {
    wechatIconSrc: require("@img/wechat.png"),
    wechatCodeSrc: require("@img/wechat-qrcode.png"),
    androidIconSrc: require("@img/android.png"),
    androidCodeSrc: require("@img/android-qrcode.png")
  }
}
}
</script>

<style lang="stylus" scoped>
.foot-wrapper
  background: #3C3C3C
  color: #ABABAB
  display: flex
  justify-content: space-between
  .manual
    padding: 30px 0px 50px 50px
    .title
      font-size: 20px
      line-height: 50px
    .content
      font-size: 12px
      line-height: 40px
  .right
    display: flex
    flex-direction: column
    justify-content: center
    margin-right: 50px
    .qrcode-list
      display: flex
      justify-content: space-around
      margin-bottom: 10px
      .qrcode-item
        display: inline-block
        padding: 10px
  
</style>